"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  /**
   * Name.
   */
  name: "ContactUs",

  /**
   * Components.
   */
  components: {},

  /**
   * Mixins.
   */
  mixins: [],

  /**
   * Props.
   */
  props: {},

  /**
   * Reactive properties.
   * @returns {{}}
   */
  data: function data() {
    return {};
  },


  /**
   * Computed properties.
   */
  computed: {},

  /**
   * Watchers.
   */
  watch: {},

  /**
   * Created hook.
   */
  created: function created() {},


  /**
   * Mounted hook.
   */
  mounted: function mounted() {},


  /**
   * Destroyed hook.
   */
  destroyed: function destroyed() {},


  /**
   * Methods.
   */
  methods: {}
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/login/ContactUs.vue
// module id = EODS
// module chunks = 0 1